export * from './uso-plataforma.component';